import { memo } from 'react';

import { useTicketingOptions } from '../../store';

import SlotIncluder from '@shared/SlotIncluder';

import * as styles from './styles.module.scss';

const Article = () => {
  const {
    options: { slotArticleLibrary },
  } = useTicketingOptions();

  if (!slotArticleLibrary) {
    return null;
  }

  return (
    <div className={styles.ticketingArticle}>
      <SlotIncluder path={slotArticleLibrary} />
    </div>
  );
};

export default memo(Article);
